module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    staticClass: "topbar",
    attrs: {
      "data-dropdown": "dropdown",
      "id": "mytopbar"
    }
  }, [_c('div', {
    staticClass: "topbar-inner",
    staticStyle: {
      "background-image": "none"
    }
  }, [_c('div', {
    staticClass: "customerlogo"
  }, [_c('a', {
    attrs: {
      "href": _vm.mainUrl,
      "title": "Inicio"
    }
  }, [_c('span')])]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-right"
  }, [_c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li', {
    staticClass: "top-languages",
    attrs: {
      "id": "languageSelector"
    }
  }, [_c('language-login', {
    attrs: {
      "lang": this.lang
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e81c89b","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/TopbarLogin.vue
// module id = 916
// module chunks = 3